import { auth } from '../config/firebase-config';

export const signOutUser = () => {
  auth.signOut()
    .then(() => {
      // Clear local storage
      sessionStorage.removeItem("ticketToken");
      window.localStorage.removeItem("auth");
      window.localStorage.removeItem("user");
      console.log("User signed out successfully.");
      window.location.href = '/';
    })
    .catch((error) => {
      console.error("Error signing out: ", error);
    });
};